// Importar dependencias
import ApiClient from "./ApiClient";

const businessesUrl = "billing/";
const billingUrl = "billing/";

// Función para configurar la facturación de un negocio
async function configureBilling(data) {
  // Realizamos la petición
  try {
    const result = await ApiClient.post(businessesUrl + "configure", data);
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

// Función para obtener la información de facturación de un negocio
async function getBillingInfo() {
  // Realizamos la petición
  try {
    const result = await ApiClient.get(businessesUrl + "info");
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

// Función para subir certificados como form data
async function uploadCert(data) {
  // Realizamos la petición
  try {
    const result = await ApiClient.post(businessesUrl + "upload-csd", data);
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

// Función para facturar
async function generateBill(data) {
  // Realizamos la petición
  try {
    const result = await ApiClient.post(businessesUrl + "generate-bill", data);
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

// Función para descargar facturas
async function downloadInvoice(invoiceId) {
  try {
    // Realizamos la petición
    const response = await ApiClient.get(
      billingUrl + `download-invoice/${invoiceId}`,
      { responseType: "arraybuffer" }
    );

    // Create a Blob from the response data
    const blob = new Blob([response.data], { type: "application/zip" });

    // Regresar datos del archivo
    return blob;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

export default {
  configureBilling,
  getBillingInfo,
  uploadCert,
  generateBill,
  downloadInvoice
};
